import { mapGetters } from "vuex";
import EplNewPaymentModeCard from "@/components/EplNewPaymentModeCard";
import EplNewPaymentSummaryCard from "@/components/EplNewPaymentSummaryCard";
import ActionButton from "@/components/ActionButton";
export default {
  name: "PaymentMode",
  computed: {
    ...mapGetters([
      "loggedIn",
      "paymentMethods",
      "payableAmount",
      "user",
      "paymentRequest"
    ])
  },
  components: {
    EplNewPaymentModeCard,
    EplNewPaymentSummaryCard,
    ActionButton
  },
  mounted() {
    this.$store.dispatch("paymentMethods");
  },
  data() {
    return {
      isLoyaltyPointsSelected: undefined
    };
  },
  methods: {
    closePaymentScreen() {
      this.$parent.showPaymentSection();
    },
    navigateBack() {
      this.$parent.showOutstandingSection();
    },
    payViaLoyalty() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "PAYMENT_METHOD_SELECTED",
        propertyName: "METHOD_NAME",
        propertyValue: "LOYALTY_POINTS"
      });
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "PAYMENT_METHOD_SELECTED",
        propertyName: "AMOUNT",
        propertyValue: this.payableAmount
      });
      localStorage.setItem("txnAmount", this.payableAmount);
      this.$store
        .dispatch("loyaltyPoints", this.paymentRequest)
        .then(() => {
          this.paymentRequest.loyaltyPointsSelected = 0;
          this.$router.push({
            name: "PaymentSuccess"
          });
        })
        .catch(() => this.$router.push({ name: "PaymentFailure" }));
    }
  },
  watch: {
    isLoyaltyPointsSelected(val) {
      if (val) {
        this.paymentRequest.loyaltyPointsSelected =
          this.user.features.loyalty.redeemable_points > this.payableAmount
            ? this.payableAmount
            : this.user.features.loyalty.redeemable_points;
        this.paymentRequest.paymentMethod =
          this.user.features.loyalty.redeemable_points >= this.payableAmount
            ? "loyaltyPoints"
            : undefined;
        this.paymentRequest.amount =
          this.paymentRequest.amount -
            this.paymentRequest.loyaltyPointsSelected <
          0
            ? 0
            : this.paymentRequest.amount -
              this.paymentRequest.loyaltyPointsSelected;
      } else {
        this.paymentRequest.amount = this.payableAmount;
        this.paymentRequest.loyaltyPointsSelected = 0;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/PaymentMode/component.js